import { createSelector } from 'reselect';
import { ScreenSize } from '../constants';
import { getMediaQueryBreakpoints } from '../reducer';

export const getCurrentScreenSize = breakpoints =>
  Object.entries(breakpoints).reduce(
    (acc, [bp, val]) => (val ? bp : acc),
    ScreenSize.XS,
  );

export default createSelector(
  [getMediaQueryBreakpoints],
  getCurrentScreenSize,
);
